if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.__pm_windowClickHandler = null;
        this.__pm_windowPointerHandler = null;
        this.__pm_handlersBound = false;

        this.__pm_isDragging = false;
        this.__pm_dragStart = null;
        this.__pm_dragResetTimer = null;
      }

      // OVERRIDE HIDE → DO NOTHING (disable close)
      hide() {
        return; // completely disable close
      }

      show(opener) {
        if (opener) this.openedBy = opener;
        super.show(opener);
        this.showActiveMedia();
         const closeBtn = this.querySelector('.model-close-button');

          if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              super.hide();  // close only on button
            });
          }
        const container =
          this.querySelector('[role="document"]') ||
          this.querySelector('.product-media-modal__dialog');

        if (!container) return;

        const isSwiperInteraction = (target) => {
          if (!target || !(target instanceof Element)) return false;
          return (
            target.closest('.swiper-container') ||
            target.closest('.swiper-wrapper') ||
            target.closest('.swiper-slide')
          );
        };

        const isAllowedClick = (target) => {
          if (!target || !(target instanceof Element)) return false;
          return (
            target.closest('[data-thumb-index]') ||
            target.closest('.product-thumbs button') ||
            target.closest('button') ||
            target.closest('input') ||
            target.closest('label') ||
            isSwiperInteraction(target)
          );
        };

        const scheduleDragReset = () => {
          if (this.__pm_dragResetTimer) clearTimeout(this.__pm_dragResetTimer);
          this.__pm_dragResetTimer = setTimeout(() => {
            this.__pm_isDragging = false;
            this.__pm_dragStart = null;
            this.__pm_dragResetTimer = null;
          }, 50);
        };

        if (!this.__pm_handlersBound) {
          // CLICK HANDLER
          this.__pm_windowClickHandler = (e) => {
            const target = e.target;

            // allow all allowed controls
            if (isAllowedClick(target)) {
              if (this.__pm_isDragging) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
              }
              return;
            }

            // prevent any background click from doing anything
            if (container.contains(target)) {
              e.stopImmediatePropagation();
              e.stopPropagation();
            }
          };

          // POINTER HANDLER
          this.__pm_windowPointerHandler = (e) => {
            const type = e.type;
            const target = e.target;

            if (type === 'pointerdown' || type === 'touchstart') {
              this.__pm_isDragging = false;

              if (isSwiperInteraction(target)) {
                const p = e.touches ? e.touches[0] : e;
                this.__pm_dragStart = { x: p.clientX, y: p.clientY };
              } else {
                this.__pm_dragStart = null;
              }

              if (container.contains(target) && !isSwiperInteraction(target)) {
                e.stopImmediatePropagation();
                e.stopPropagation();
              }

              return;
            }

            if (type === 'pointermove') {
              if (this.__pm_dragStart) {
                const p = e.touches ? e.touches[0] : e;
                if (
                  Math.abs(p.clientX - this.__pm_dragStart.x) > 5 ||
                  Math.abs(p.clientY - this.__pm_dragStart.y) > 5
                ) {
                  this.__pm_isDragging = true;
                }
              }
              return;
            }

            if (type === 'pointerup' || type === 'touchend' || type === 'pointercancel') {
              if (this.__pm_dragStart && this.__pm_isDragging) {
                scheduleDragReset();
              } else {
                this.__pm_isDragging = false;
                this.__pm_dragStart = null;
              }

              if (container.contains(target) && !isSwiperInteraction(target)) {
                e.stopImmediatePropagation();
                e.stopPropagation();
              }

              return;
            }
          };

          // ATTACH HANDLERS
          window.addEventListener('click', this.__pm_windowClickHandler, true);
          window.addEventListener('pointerdown', this.__pm_windowPointerHandler, true);
          window.addEventListener('pointermove', this.__pm_windowPointerHandler, true);
          window.addEventListener('pointerup', this.__pm_windowPointerHandler, true);

          window.addEventListener('touchstart', this.__pm_windowPointerHandler, {
            capture: true,
            passive: false,
          });
          window.addEventListener('touchend', this.__pm_windowPointerHandler, {
            capture: true,
          });
          window.addEventListener('pointercancel', this.__pm_windowPointerHandler, true);

          this.__pm_handlersBound = true;
        }
      }

      showActiveMedia() {
        const openerId = this.openedBy?.getAttribute('data-media-id') ?? null;

        if (!openerId) return;

        const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeMedia = mediaElements.find(
          (element) => element.getAttribute('data-media-id') === openerId
        );

        if (!activeMedia) return;

        mediaElements
          .filter((element) => element !== activeMedia)
          .forEach((element) => element.classList.remove('active'));
        activeMedia.classList.add('active');

        const slide = activeMedia.closest('.swiper-slide');
        const swiper = slide?.closest('.swiper-container')?.swiper;

        if (swiper && slide) {
          const slideIndex = Array.from(swiper.slides).indexOf(slide);
          if (slideIndex >= 0 && swiper.activeIndex !== slideIndex) {
            swiper.slideTo(slideIndex);
          }
          return;
        }

        activeMedia.scrollIntoView({
          block: 'nearest',
          inline: 'center',
        });

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft =
            activeMedia.offsetLeft - (container.clientWidth - activeMedia.offsetWidth) / 2;
        }
      }
    }
  );
}
